<template>
  <div class="rent-container col-xs-12 p0 fs-medium-small">
    <div class="row mx0 end-xs rent-header flex pointer" :class="{'rent-header-try-on': isTryOn}" @click="openBody">
      <div class="col-xs-2">
        <div class="circle">
          <div v-show="isBodyOpen" class="full-circle" />
        </div>
      </div>
      <div class="col-xs col-md-10 col-lg-10 col-xl align-left nowrap-title">
        <p class="mb5">
          <b>{{ $t(header.mainTitle) }} <span class="first-line-sub">{{ header.subscriptionName }}</span></b>
        </p>
        <p v-if="header.subscriptionName" class="mt0 mb5 second-line-sub">
          <b>{{ header.subscriptionName }}</b>
        </p>
      </div>
      <div class="col-xs-4 col-md-10 col-lg-10 col-xl pr15 align-right xl-align-left">
        <p class="nowrap mb0">
          <b>{{ (header.subscriptionName || header.headerPrice || header.activeSubscription) ? '' : $t("fromV2") }} {{ header.price | price(storeView) }}</b>
        </p>
      </div>
    </div>
    <div class="row mx0 rent-header pointer" @click="openBody">
      <div class="col-xs-2" />
      <div class="col-xs-10">
        <p class="align-left mt5 xl-m0">
          {{ $t(header.subtitle) }}
        </p>
      </div>
    </div>
    <div class="p20 inner" v-show="isBodyOpen">
      <slot />
    </div>
  </div>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  name: 'MainRent',
  props: {
    header: {
      type: Object,
      default: () => {}
    },
    firstAvailable: {
      type: String,
      default: ''
    },
    isTryOn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isBodyOpen: false
    }
  },
  computed: {
    storeView () {
      return currentStoreView()
    }
  },
  mounted () {
    this.openSingleRent()
    this.$bus.$on('rent-close', () => {
      this.isBodyOpen = false
    })
  },
  methods: {
    openSingleRent () {
      if (this.header.mainTitle === this.firstAvailable) {
        this.$bus.$emit('rent-close')
        this.isBodyOpen = true
      }
    },
    openBody () {
      this.$bus.$emit('rent-close')
      this.$bus.$emit('resetCalendarDate')
      this.isBodyOpen = !this.isBodyOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.rent-container {
border: 1px solid black;
}
.rent-header {
background-color: #F5F5F5;
}
.circle {
width: 26px;
height: 26px;
border-radius: 50%;
background-color: #F5F5F5;
border: 1px solid black;
margin: 14px auto auto auto;
display: flex;
align-items: center;
justify-content: center;
}
.full-circle {
width: 18px;
height: 18px;
border-radius: 50%;
background-color: black;
border: 1px solid black;
margin: 0 auto;
}
.nowrap {
  white-space: nowrap;
}
.nowrap-title {
  @media (min-width: 1500px) {
    white-space: nowrap;
  }
}
.xl-align-left {
  @media (min-width: 768px) and (max-width: 1366px) {
    p {
      margin-top: 0;
    }
    text-align: left;
  }
}
.xl-m0 {
    @media (min-width: 1366px) {
    margin-top: 0;
  }
}
.first-line-sub {
  @media (max-width: 1500px) {
    display: none;
  }
  @media (min-width: 1500px) {
    display: inline-block;
  }
}
.second-line-sub {
  @media (max-width: 1500px) {
    display: block;
  }
  @media (min-width: 1500px) {
    display: none;
  }
}
</style>
